import { useEffect } from "react";
import { useLocation } from "wouter";

// Reused verbatim from SpotMeter.
export function ScrollToTop() {
  const [location] = useLocation();
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location]);
  return null;
}
